import { z } from 'zod'

export const createCampaignSchema = z
  .object({
    name: z
      .string()
      .min(1, 'Tên campaign không được để trống')
      .max(100, 'Tên campaign không được quá 100 ký tự'),
    description: z.string().optional(),
    howToPlay: z
      .string()
      .max(2000, 'Hướng dẫn chơi không được quá 2000 ký tự')
      .optional(),
    rules: z
      .string()
      .max(2000, 'Quy định không được quá 2000 ký tự')
      .optional(),
    templateId: z.string().min(1, 'Vui lòng chọn template game'),
    startDate: z.date({
      message: 'Vui lòng chọn ngày bắt đầu',
    }),
    endDate: z.date({
      message: 'Vui lòng chọn ngày kết thúc',
    }),
    maxPlaysPerUser: z
      .number()
      .min(1, 'Số lượt chơi tối thiểu là 1')
      .max(100, 'Số lượt chơi tối đa là 100'),
    authenticationRequired: z.boolean(),
    playCodeRequired: z.boolean(),
    distributionType: z.enum(['Instant', 'RankBased'], {
      message: 'Vui lòng chọn kiểu phân phối',
    }),
    gameConfigOverride: z.record(z.string(), z.any()).optional(),
    uiConfigOverride: z.record(z.string(), z.any()).optional(),
  })
  .refine((data) => data.endDate > data.startDate, {
    message: 'Ngày kết thúc phải sau ngày bắt đầu',
    path: ['endDate'],
  })

export type CreateCampaignFormData = z.infer<typeof createCampaignSchema>
